/**
 * Nutzungsbedingungen der Testfassung samt Anlage zur Auftragsverarbeitung.
 *
 * Warum das hier steht und nicht als PDF irgendwo liegt: der Nutzer schliesst
 * diese Bedingungen mit dem Haekchen auf der Startseite ab. Art. 28 Abs. 9
 * DSGVO verlangt Textform und laesst das elektronische Format ausdruecklich
 * zu, eine Unterschrift ist nicht noetig. Also muss der Text vor dem Haekchen
 * erreichbar sein.
 */
import { Link } from 'react-router'

export function BedingungenSeite() {
  return (
    <div className="recht-seite">
      <div className="recht-spalte">
        <Link to="/" className="verweis zurueck">
          Zurück zum Test
        </Link>

        <h1>Nutzungsbedingungen für die Testfassung</h1>
        <p className="leiser">Fassung 2026-09-20</p>

        <h2>1. Anbieter</h2>
        <p>
          H&amp;K Automation GbR, Obere Burghalde 92, 71229 Leonberg. Gesellschafter sind Louis Honal und Sven
          Konstantinow. Kontakt: louis.honal@hks-automation.de.
        </p>

        <h2>2. Was die Testfassung ist</h2>
        <p>
          Die Testfassung zeigt kostenlos, wie das Werkzeug aus einem Kontoauszug eine Importdatei für DATEV macht. Ein
          Testzugang umfasst zwei Kontoauszüge, danach nimmt er nichts Neues mehr an. Die eigenen Dateien bleiben
          erreichbar, bis die Löschfrist greift. Ein Anspruch auf Verfügbarkeit besteht nicht, der Zugang kann jederzeit
          enden.
        </p>

        <h2>3. Was Sie zusichern</h2>
        <p>
          Sie laden nur Unterlagen hoch, für die Sie das Recht dazu haben. Sie handeln dabei als Verantwortlicher im
          Sinne der DSGVO. Für einen reinen Funktionstest empfehlen wir anonymisierte Auszüge oder Musterdaten. Laden
          Sie echte Mandantendaten nur hoch, wenn Sie als Verantwortlicher dazu befugt sind. Zum Ausprobieren genügt ein
          einzelner Auszug, ganze Mandantenbestände sind dafür nicht nötig.
        </p>

        <h2>4. Ergebnis ohne Gewähr</h2>
        <p>
          Das Werkzeug rechnet jede Datei nach: Anfangssaldo plus Buchungen muss den Schlusssaldo auf den Cent ergeben,
          und jede erzeugte camt-Datei wird gegen das offizielle Schema geprüft. Trotzdem ist die Testfassung eine
          Vorführung. Prüfen Sie das Ergebnis, bevor Sie es in DATEV importieren. DATEV nimmt einen Import nicht
          zurück. Für Schäden aus einem ungeprüften Import haften wir nicht, im Übrigen haften wir nur für Vorsatz und
          grobe Fahrlässigkeit sowie bei Verletzung von Leben, Körper und Gesundheit.
        </p>

        <h2>5. Faire Nutzung</h2>
        <p>
          Ein Zugang gehört zu einer Person. Automatisierte Zugriffe, mehrere Zugänge zum Umgehen des Kontingents und
          Versuche, das Werkzeug zu stören, sind nicht erlaubt. Wir zählen je Anschluss und Tag, wie viele Zugänge
          angelegt wurden, und speichern dafür nur einen Hashwert, nicht die IP-Adresse selbst.
        </p>

        <h2>6. Recht</h2>
        <p>Es gilt deutsches Recht. Gerichtsstand ist, soweit zulässig, Stuttgart.</p>

        <hr />

        <h1 id="avv">Anlage: Vereinbarung zur Auftragsverarbeitung</h1>
        <p className="leiser">
          Nach Art. 28 DSGVO, geschlossen zwischen Ihnen als Verantwortlichem und H&amp;K Automation GbR als
          Auftragsverarbeiter, wirksam mit dem Start eines Testzugangs.
        </p>

        <h2>1. Gegenstand, Art und Zweck</h2>
        <p>
          Der Auftragsverarbeiter liest hochgeladene Kontoauszüge maschinell aus, rechnet sie nach und erzeugt daraus
          eine Importdatei im Format camt.053 oder MT940. Weitere Zwecke gibt es nicht.
        </p>

        <h2>2. Dauer</h2>
        <p>
          Für die Dauer des Testzugangs. Originale, gelesene Daten und erzeugte Dateien werden 30 Tage nach dem
          Export gelöscht, ohne dass Sie etwas tun müssen. Auf Wunsch löschen wir den Zugang sofort, eine Mail an
          louis.honal@hks-automation.de genügt.
        </p>

        <h2>3. Art der Daten und Kreis der Betroffenen</h2>
        <p>
          Verarbeitet werden die Angaben, die auf einem Kontoauszug stehen: Kontoinhaber, IBAN und BIC, Salden,
          Buchungsbeträge und Buchungstexte, Namen und Kontodaten der Zahlungsbeteiligten sowie Verwendungszwecke.
          Betroffen sind damit Ihre Mandanten und deren Zahlungspartner. Bitte laden Sie keine besonderen Kategorien
          personenbezogener Daten nach Art. 9 DSGVO hoch.
        </p>

        <h2>4. Weisungen</h2>
        <p>
          Der Auftragsverarbeiter verarbeitet die Daten ausschließlich nach Ihren Weisungen. Die Nutzung des Werkzeugs
          ist die Weisung. Weitere Weisungen richten Sie an louis.honal@hks-automation.de. Hält der Auftragsverarbeiter eine
          Weisung für rechtswidrig, weist er darauf hin. Eine Verarbeitung oder Übermittlung in ein Land außerhalb der
          EU findet nur auf Ihre dokumentierte Weisung oder aufgrund einer gesetzlichen Pflicht statt. Im Regelbetrieb
          geschieht das nicht.
        </p>

        <h2>5. Vertraulichkeit und Berufsgeheimnis</h2>
        <p>
          Alle mit der Verarbeitung befassten Personen sind zur Vertraulichkeit verpflichtet. Der Auftragsverarbeiter
          und seine Beschäftigten sind darüber hinaus als mitwirkende Personen im Sinne des § 203 Abs. 3 und 4 StGB zur
          Verschwiegenheit verpflichtet und wissen, dass sie sich strafbar machen, wenn sie fremde Geheimnisse
          offenbaren, die ihnen bei dieser Tätigkeit bekannt werden. Auch die eingesetzten Unterauftragsverarbeiter
          werden als weitere mitwirkende Personen im Sinne des § 203 Abs. 4 StGB zur Verschwiegenheit verpflichtet. Sie
          als Steuerberater stellen sicher, dass Sie zur Offenbarung dieser Unterlagen gegenüber dem Auftragsverarbeiter
          befugt sind, im Rahmen von § 62a StBerG und Ihrer Mandatsvereinbarung.
        </p>

        <h2>6. Technische und organisatorische Maßnahmen</h2>
        <ul>
          <li>Übertragung ausschließlich über TLS</li>
          <li>Originale und erzeugte Dateien verschlüsselt gespeichert, AES-256-GCM</li>
          <li>Jeder Zugang arbeitet in einem eigenen, abgetrennten Bereich. Jede Abfrage filtert nach diesem Bereich, niemand sieht die Daten eines anderen</li>
          <li>Passwörter werden nur als Argon2id-Hash gespeichert, nie im Klartext</li>
          <li>Kein Zugriff auf Inhalte durch den Anbieter im laufenden Test, das Protokoll enthält keine Beträge, Namen oder IBAN</li>
          <li>Keine Verwendung der Daten für das Training von KI-Modellen</li>
          <li>Automatische Löschung nach der Frist, ohne Sicherungskopie der Inhalte</li>
          <li>Verfügbarkeit und Wiederherstellbarkeit durch getrennte Speicherung und geprüfte Wiederanlaufverfahren</li>
          <li>Zugriff auf die Systeme nur für einen benannten, klein gehaltenen Kreis, protokolliert</li>
          <li>Die Wirksamkeit dieser Maßnahmen wird regelmäßig überprüft</li>
        </ul>

        <h2>7. Unterauftragsverarbeiter</h2>
        <p>Mit Abschluss dieser Vereinbarung genehmigen Sie den Einsatz folgender Unterauftragsverarbeiter:</p>
        <ul>
          <li>
            <b>Hetzner Online GmbH</b>, Industriestraße 25, 91710 Gunzenhausen. Betrieb der Server, Standort
            Deutschland.
          </li>
          <li>
            <b>Amazon Web Services EMEA SARL</b>, 38 Avenue John F. Kennedy, L-1855 Luxemburg. Bereitstellung des
            Sprachmodells über Amazon Bedrock in der Region Frankfurt. Die Verarbeitung findet ausschließlich in der EU
            statt. Die Inhalte werden nicht gespeichert und nicht zum Training verwendet.
          </li>
        </ul>
        <p>
          Die Verarbeitung findet ausschließlich auf Servern in Deutschland und in der EU statt. Vertragspartner für
          das Sprachmodell ist die Amazon Web Services EMEA SARL mit Sitz in Luxemburg. Da Amazon zu einem US-Konzern
          gehört, ist ein Zugriff durch Stellen außerhalb der EU rechtlich nicht vollständig auszuschließen. Für diesen
          Fall gelten die EU-Standardvertragsklauseln und ergänzende Schutzmaßnahmen, der Auftragsverarbeiter hat
          vertraglich keinen Zugriff zu eigenen Zwecken. Wir verpflichten jeden Unterauftragsverarbeiter zu denselben
          Datenschutzpflichten, die in dieser Vereinbarung gelten, und haften für deren Einhaltung. Wechselt ein
          Unterauftragsverarbeiter, informieren wir mindestens 14 Tage vorher und Sie können widersprechen.
        </p>

        <h2>8. Ihre Rechte und Pflichten des Auftragsverarbeiters</h2>
        <p>
          Der Auftragsverarbeiter unterstützt Sie bei Anfragen betroffener Personen sowie bei Ihren Pflichten nach
          Art. 32 bis 36 DSGVO, soweit das im Rahmen dieser kurzen Verarbeitung möglich ist. Er meldet Ihnen eine
          Verletzung des Schutzes personenbezogener Daten ohne schuldhaftes Zögern, in der Regel innerhalb von
          48 Stunden nach Kenntnis, mit den Angaben nach Art. 33 Abs. 3 DSGVO. Erreichen ihn Anfragen betroffener
          Personen unmittelbar, beantwortet er sie nicht selbst, sondern leitet sie an Sie weiter. Auf Anfrage weist er
          die Einhaltung dieser Vereinbarung nach und ermöglicht Prüfungen durch Sie oder einen von Ihnen beauftragten
          Prüfer, nach angemessener Ankündigung.
        </p>

        <h2>9. Löschung</h2>
        <p>
          Nach Ablauf der Frist werden alle Inhalte gelöscht. Auf Wunsch bestätigen wir die Löschung. Eine Rückgabe der
          Inhalte ist auf Ihre Wahl möglich, im Regelfall aber entbehrlich, weil Sie die erzeugte Datei selbst
          heruntergeladen haben. Gibt es eine gesetzliche Aufbewahrungspflicht, bleibt nur das, was diese verlangt.
        </p>

        <h2>10. Ihre eigenen Angaben</h2>
        <p>
          Für den Zugang speichern wir Vorname, Nachname, E-Mail-Adresse und, falls angegeben, den Kanzleinamen. Wir
          nutzen sie, um den Zugang bereitzustellen und um Ihnen zu schreiben, wenn Sie Fragen haben oder wir fragen,
          wie der Test gelaufen ist. Diese Angaben gehören nicht zur Auftragsverarbeitung, dort sind Sie selbst
          betroffen. Sie können der weiteren Nutzung jederzeit widersprechen und die Löschung verlangen, eine Mail an
          louis.honal@hks-automation.de genügt.
        </p>

        <Link to="/" className="verweis zurueck">
          Zurück zum Test
        </Link>
      </div>
    </div>
  )
}
